// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tQrCz","productName":"Table_productName__MaM5I"};